/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  createCampaign,
  enrollProspects,
  getCampaign,
  listCampaigns,
  listEnrollments,
  setCampaignStatus,
  updateCampaign,
} from '../actions/outreachCampaign';
import { OutreachCampaignState } from '../types/outreachCampaign';

const initialState: OutreachCampaignState = {
  campaigns: [],
  isLoadingList: false,
  current: undefined,
  isLoadingCurrent: false,
  isSaving: false,
  enrollments: [],
  enrollmentsTotal: 0,
  enrollmentsPage: 1,
  enrollmentsTotalPages: 0,
  isLoadingEnrollments: false,
  isEnrolling: false,
};

const outreachCampaignSlice = createSlice({
  name: 'outreachCampaign',
  initialState,
  reducers: {
    clearCurrentCampaign: (state) => {
      state.current = undefined;
      state.enrollments = [];
      state.enrollmentsTotal = 0;
      state.enrollmentsPage = 1;
      state.enrollmentsTotalPages = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listCampaigns.pending, (state) => {
        state.isLoadingList = true;
      })
      .addCase(listCampaigns.fulfilled, (state, action) => {
        state.isLoadingList = false;
        state.campaigns = action.payload.campaign_list ?? [];
      })
      .addCase(listCampaigns.rejected, (state) => {
        state.isLoadingList = false;
      })
      .addCase(getCampaign.pending, (state) => {
        state.isLoadingCurrent = true;
      })
      .addCase(getCampaign.fulfilled, (state, action) => {
        state.isLoadingCurrent = false;
        state.current = action.payload;
      })
      .addCase(getCampaign.rejected, (state) => {
        state.isLoadingCurrent = false;
      })
      .addCase(createCampaign.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.isSaving = false;
        state.current = action.payload;
      })
      .addCase(createCampaign.rejected, (state) => {
        state.isSaving = false;
      })
      .addCase(updateCampaign.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
        state.isSaving = false;
        state.current = action.payload;
      })
      .addCase(updateCampaign.rejected, (state) => {
        state.isSaving = false;
      })
      .addCase(setCampaignStatus.fulfilled, (state, action) => {
        state.current = action.payload;
      })
      .addCase(enrollProspects.pending, (state) => {
        state.isEnrolling = true;
      })
      .addCase(enrollProspects.fulfilled, (state) => {
        state.isEnrolling = false;
      })
      .addCase(enrollProspects.rejected, (state) => {
        state.isEnrolling = false;
      })
      .addCase(listEnrollments.pending, (state) => {
        state.isLoadingEnrollments = true;
      })
      .addCase(listEnrollments.fulfilled, (state, action) => {
        state.isLoadingEnrollments = false;
        state.enrollments = action.payload.enrollment_list ?? [];
        state.enrollmentsTotal = action.payload.total ?? 0;
        state.enrollmentsPage = action.payload.page ?? 1;
        state.enrollmentsTotalPages = action.payload.total_pages ?? 0;
      })
      .addCase(listEnrollments.rejected, (state) => {
        state.isLoadingEnrollments = false;
      });
  },
});

export const { clearCurrentCampaign } = outreachCampaignSlice.actions;
export default outreachCampaignSlice.reducer;
